import { setTerm } from './helpers';

export const setPriceType = setTerm('price_sm');
